// extracted by mini-css-extract-plugin
export default {"SettingsSection":"CallsSettings_SettingsSection__0EtcN","settingsTitle":"CallsSettings_settingsTitle__0xzT3"};